import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getRateLimitLogs = ({ email, filterMonth, limit, skip }: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/rate-limit-log/get-list`, {
      params: { email, filter_by_month: filterMonth, limit, skip }
    })

export const truncateRateLimitLogs = (query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/rate-limit-log/truncate`, { data: query })

export const deleteRateLimitLogs = ({ filterMonth, query }: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/rate-limit-log/delete`, { 
      params: { filter_by_month: filterMonth },
      data: query 
    })
